<template>
  <div class="searchQuery_admin">
    <!--<div class="resize-line" id="resize-line-comm"></div>-->
    <div :class="[queryStart&&!QueryListRoute ? 'searchQuery_max' : '']">
      <el-form label-position="right" label-width="80px" size="mini">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-row :gutter="20">
              <el-col :span="itme.colSpan!=undefined ?itme.colSpan :6" v-for="(itme, key) in fromList" :key="key">
                <el-form-item :label="`${itme.label}`">
                  <el-input size="mini" v-if="itme.type === 'input'" clearable v-model="fromData[itme.key]">
                    <template slot="append">
                      <p style="cursor: pointer; text-align: center;" @click="openDialog(itme.dialog, itme.code)"
                         v-if="itme.tips">{{itme.tips}}</p>
                    </template>
                  </el-input>
                  <el-select collapse-tags v-if="itme.type === 'select'" v-model="fromData[itme.key]" :multiple="itme.multiple"
                             clearable filterable placeholder="请选择">
                    <el-option
                      v-for="(val, index) in itme.valData"
                      :key="index"
                      :label="val[itme.labelVal]"
                      :value="val[itme.value]">
                      <!--v-show="fromData[itme.key].indexOf(val[itme.value]) === -1"-->
                    </el-option>
                  </el-select>
                  <el-date-picker
                    v-if="itme.type === 'timeSelect'"
                    v-model="fromData[itme.key]"
                    align="right"
                    type="datetime"
                    :clearable="false"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期"></el-date-picker>
                  <el-autocomplete
                    v-if="itme.type === 'inputCustom'"
                    v-model="fromData[itme.key]"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="inputSelectEven">
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.BLNO }}</div>
                    </template>
                  </el-autocomplete>
                  <el-checkbox-group v-if="itme.type === 'checkbox'" v-model="fromData[itme.key]">
                    <el-checkbox v-for="(val, index) in itme.valData"
                                 :key="index"
                                 :label="val[itme.value]">{{val[itme.labelVal]}}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <div class="searchQuery_query" style="text-align: center; margin-bottom: 10px">
              <el-button class="mediumBtn" type="primary" size="medium" icon="el-icon-search" @click="queryEven">查询
              </el-button>
            </div>
       <!--     <div v-if="fromList.length > 6 && !QueryListRoute">
              <p style="text-align: center;" class="searchQuery_queryp" v-if="queryStart"><span style="cursor:pointer;"
                                                                                                @click="queryStart = !queryStart"><i
                class="el-icon-sort-down"/>展开</span></p>
              <p style="text-align: center;" class="searchQuery_queryp" v-else><span style="cursor:pointer;"
                                                                                     @click="queryStart = !queryStart"><i
                class="el-icon-sort-up"/>收起</span></p>
            </div>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <grid-dialog :show="showBargainID"
                 title="合同选择"
                 :default-params="bargainIDDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="bargainDefaultValue"
                 :default-keys="bargainDefaultKeys"
                 :ref-value.sync="fromData"
                 @close="showBargainID = !showBargainID"></grid-dialog>
    <grid-dialog :show="showGoodsID"
                 title="产品选择"
                 :default-params="refGoodsDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="refgoodsDefaultValue"
                 :default-keys="goodsDefaultKeys"
                 :ref-value.sync="fromData"
                 @close="showGoodsID = !showGoodsID"></grid-dialog>
    <grid-dialog :show="showmainOrderGetTGuest"
                 title="提货人选择"
                 :default-params="mainOrderGetTGuest"
                 :grid-config="dictionaryAction"
                 :default-values.sync="TGuestIDDefaultValue"
                 :default-keys="TGuestIDDefaultKey"
                 :ref-value.sync="fromData"
                 @close="showmainOrderGetTGuest = !showmainOrderGetTGuest"></grid-dialog>
    <grid-dialog :show="showgetTGuest"
                 title="提货人选择"
                 :default-params="TGuestIDDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="TGuestIDDefaultValue"
                 :default-keys="TGuestIDDefaultKey"
                 :ref-value.sync="fromData"
                 @close="showgetTGuest = !showgetTGuest"></grid-dialog>
    <grid-dialog :show="showgetTGuest2"
                 title="提货人选择"
                 :default-params="TGuestIDDefaultParams2"
                 :grid-config="dictionaryAction"
                 :default-values.sync="TGuestIDDefaultValue"
                 :default-keys="TGuestIDDefaultKey"
                 :ref-value.sync="fromData"
                 @close="showgetTGuest2 = !showgetTGuest2"></grid-dialog>
    <grid-dialog :show="showgetTankId"
                 title="罐号选择"
                 :default-params="TankIdDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="TankIDDefaultValue"
                 :default-keys="TankIDDefaultKey"
                 :ref-value.sync="fromData"
                 @close="showgetTankId = !showgetTankId"></grid-dialog>
    <grid-dialog :show="showGoodsIDBillQuery"
                 title="产品选择"
                 :default-params="GoodsDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="goodsDefaultValue"
                 :default-keys="goodsDefaultKeys"
                 :ref-value.sync="fromData"
                 @close="showGoodsIDBillQuery = !showGoodsIDBillQuery"></grid-dialog>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import gridDialog from '@/components/gridDialog';

  export default {
    name: 'customerServiceSearchQuery',
    components: {
      gridDialog,
    },
    props: {
      height: {
        request: true,
      },
      fromList: {
        request: true,
      },
      isShow: {
        request: false
      },
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        goodDicList: 'dictionary/goodDicList',
        dictionaryAction: 'dictionary/dictionaryAction',
        guestIDByConditionsList: 'dictionary/guestIDByConditionsList',
        bargainIDByConditionsList: 'dictionary/bargainIDByConditionsList',
        refGoodsByConditionsList: 'dictionary/refGoodsByConditionsList',
        TGuestIDByConditions: 'dictionary/TGuestIDByConditionsAction',
        TankIDByConditions: 'dictionary/TankIDByConditions',
        GoodsAction: 'dictionary/GoodsAction',
      }),
      bargainIDDefaultParams() {
        let params = {
          bargainId: '',
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getBargain',
          params,
        };
        return info;
      },
      refGoodsDefaultParams() {
        let params = {
          goodsId: this.fromData.goodsName,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getRefGoods',
          params,
        };
        return info;
      },
      mainOrderGetTGuest() {
        let params = {
          guestId: this.fromData.Name,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'mainOrderGetTGuest',
          params,
        };
        return info;
      },
      TGuestIDDefaultParams() {
        let params = {
          guestId: this.fromData.Name,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getTGuest',
          params,
        };
        return info;
      },
      TGuestIDDefaultParams2() {
        let params = {
          guestId: '',
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getTGuest2',
          params,
        };
        return info;
      },
      TankIdDefaultParams() {
        let params = {
          tankId: this.fromData.tankId,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getTank',
          params,
        };
        return info;
      },
      GoodsDefaultParams() {
        let params = {
          goodsId: this.fromData.goodsName,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getGoods',
          params,
        };
        return info;
      },
      batchNumberCol() {
        let arr = [];
        this.carOrderBatch.forEach(itme => {
          let info = {field: itme.fieldName, title: itme.fieldAlias, width: itme.displayWidth, readOnly: itme.readOnly};
          arr.push(info);
        });
        return arr;
      },
      licenseNumberClo() {
        let arr = [];
        this.carOrderList.forEach(itme => {
          let info = {field: itme.fieldName, title: itme.fieldAlias, width: itme.displayWidth, readOnly: itme.readOnly};
          arr.push(info);
        });
        return arr;
      },
    },
    data() {
      return {
        queryStart: false,
        QueryListRoute: false,
        showGoodDic: false,
        labelPosition: true,
        defaultValue: {
          goodsId: '',
          goodsName: '',
        },
        billlist: [],
        billlistColor: [
          {
            label: '已创建',
            key: '0',
            color: '#80AB00'
          }, {
            label: '已操作完成',
            key: '1',
            color: '#0000FF'
          }, {
            label: '已有效',
            key: '90',
            color: '#8080FF'
          }, {
            label: '操作中',
            key: '91',
            color: '#804000'
          }, {
            label: '审核中',
            key: '99',
            color: '#008040'
          }, {
            label: '已完成',
            key: '100',
            color: '#000040'
          }, {
            label: '已作废',
            key: '-1',
            color: '#FF0000'
          },
        ],
        fromData: {
          serviceId: [true, true],
          state: [],
          Name: '',
          goodsName: ''
        },
        showmainOrderGetTGuest: false,
        showGuestId: false,
        showBargainID: false,
        showGoodsID: false,
        showgetTGuest: false,
        showgetTGuest2: false,
        showgetTankId: false,
        showGoodsIDBillQuery: false,
        guestIdDefaultValue: {
          GuestID: 'vGuestId',
        },
        guestIdDefaultKeys: 'GuestID',
        refgoodsDefaultValue: {
          Name: 'goodsName',
          GoodsID: 'goodsId',
        },
        goodsDefaultValue: {
          Name: 'goodsName',
          GoodsID: 'goodsId',
        },
        goodsDefaultKeys: 'goodsId',
        TGuestIDDefaultValue: {
          GuestID: 'tGuestId',
          Name: 'Name',
        },
        TankIDDefaultValue: {
          TankID: 'tankId',
        },
        TGuestIDDefaultCondition: [
          {
            label: '客户编号',
            key: 'guestId',
            placeholder: '请输入客户编号',
            value: '',
          },
        ],
        TGuestIDDefaultKey: 'GuestID',
        TankIDDefaultKey: 'TankID',
        bargainDefaultValue: {
          BargainID: 'BargainID',
        },
        bargainDefaultCondition: [
          {
            label: '合同编号',
            key: 'bargainId',
            placeholder: '请输入合同编号',
            value: '',
          },
        ],
        bargainDefaultKeys: 'bargainId',
        carOrderBatchComponent: {
          select: ['TankID', 'BatchID'],
          checked: ['IsInTrade', 'IsOutTrade', 'IsTax'],
        },
        carOrderListComponent: {
          select: [],
          checked: ['IsDate'],
        },
        TGuestIDDefaultParamsCondition: [
          {
            label: '提货人编号',
            key: 'guestId',
            placeholder: '请输入提货人编号',
            value: '',
          },
        ],
        TankIdDefaultParamsCondition: [
          {
            label: '罐号',
            key: 'TankID',
            placeholder: '请输入罐号',
            value: '',
          },
        ],
        GoodsDefaultParamsCondition: [
          {
            label: '产品编号',
            key: 'GoodsID',
            placeholder: '请输入产品编号',
            value: '',
          },
        ],
      };
    },
    created() {
      this.fromList.forEach(itme => {
        this.$set(this.fromData, itme.key, '');
        if (itme.default) {
          this.fromData[itme.key] = itme.default;
        }
        if (itme.type === 'checkbox' || (itme.type === 'select' && itme.multiple)) {
          this.fromData[itme.key] = [];
          itme.valData.forEach(val => {
            if (val.ifChecked) {
              this.fromData[itme.key].push(val[itme.value]);
            }
          })
        }
      });
      // this.getGuestIDByConditionsList();
      // this.getBargainIDByConditionsList();
      // this.getRefGoodsByConditionsList();
      // this.getCarOrderBatch();
      // this.getCarOrderList();
      // this.getTGuestIDByConditions();
      // this.getTankIDByConditions(true);
      // this.getGoodsAction();
      // this.getStateList();
    },
    activated() {
      this.QueryListRoute = this.$route.name === 'adminBillLading';
    },
    methods: {
      ...mapActions({
        getDictionaryAction: 'dictionary/getDictionaryAction',
        getGuestIDByConditionsList: 'dictionary/getGuestIDByConditionsList',
        getBargainIDByConditionsList: 'dictionary/getBargainIDByConditionsList',
        getRefGoodsByConditionsList: 'dictionary/getRefGoodsByConditionsList',
        getCarOrderBatch: 'dictionary/getCarOrderBatch',
        getCarOrderList: 'dictionary/getCarOrderList',
        getTGuestIDByConditions: 'dictionary/getTGuestIDByConditionsAction',
        getTankIDByConditions: 'dictionary/getTankIDByConditions',
        getGoodsAction: 'dictionary/getGoodsAction',
      }),
      checkBox() {
        this.fromList.forEach(itme => {
          if (itme.type === 'checkbox' || (itme.type === 'select' && itme.multiple)) {
            this.fromData[itme.key] = [];
            itme.valData ? itme.valData.forEach(val => {
              if (val.ifChecked) {
                this.fromData[itme.key].push(val[itme.value]);
              }
            }) : '';
          }
        });
      },
      inputSelectEven(value) {
        this.fromData.blno = value.BLNO;
      },
      querySearch(queryString, cb) {
        let list = []
        this.fromList.forEach(itme => {
          if (itme.label === '提单号') {
            list = itme.valData
          }
        })
        let restaurants = list;
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return restaurant => {
          return (restaurant.BLNO.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      openGoodDic() {
        this.showGoodDic = !this.showGoodDic;
      },
      queryEven() {
        this.fromList.every(v => {
          return (v.type === 'timeSelect' && this.fromData[v.key]) || v.type !== 'timeSelect';
        }) ? this.$emit('queryEven') : this.$message({
          message: '时间条件不可以为空！',
          type: 'warning',
        });
      },
      openDialog(key, code) {
        if (key === 'batch') {
          this.getInCarBatchId();
          return;
        }
        this.getDictionaryAction(code);
        this[key] = !this[key];
      },
      resizeSearch(type) {
        const resize = document.getElementById(`resize-line-comm`);
        const searchQuery = document.getElementById(`lading_conter_search-${type}`);
        resize.onmousedown = e => {
          let startX = e.clientX;
          resize.left = resize.offsetLeft;
          document.onmousemove = e => {
            let endX = e.clientX;
            let moveLen = endX - startX;
            if (searchQuery.offsetWidth < 250 || searchQuery.offsetWidth > 500) return;
            if (searchQuery.offsetWidth - moveLen <= 250) return;
            if (searchQuery.offsetWidth - moveLen >= 500) return;
            searchQuery.style.width = (searchQuery.offsetWidth - moveLen) + 'px';
            startX = endX;

            let width = searchQuery.offsetWidth - moveLen
            if (width < 320) this.labelPosition = false
            else this.labelPosition = true
          };
          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
            resize.releaseCapture && resize.releaseCapture();
          };
          resize.setCapture && resize.setCapture();
          return false;
        };
      },
    },
    watch: {
      fromList() {
        this.checkBox();
      }
    }
  };
</script>
<style lang="scss">
  .searchQuery_admin {
    border-left: 0;
    position: relative;
    width: 100%;
    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
    .el-form-item {
      margin-bottom: 3px;
    }
    .el-form-item__label {
      padding-top: 0;
    }
    .resize-line {
      height: 100%;
      width: 1px;
      background-color: #ebeef5;
      position: absolute;
      padding: 0 2px;
      left: -1px;
      top: 0;

      &:hover {
        cursor: w-resize;
      }
    }
    .searchQuery_max {
      .el-row {
        overflow-y: hidden;
        height: 80px;
        margin: 0;
      }
    }
    .el-autocomplete {
      width: 100%;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 10px !important;
    }

  }

  .mediumBtn {
    padding: 10px 20px;
  }
</style>
